import Glider from 'glider-js';
import $ from 'jquery';

export const init = () => {
	const addGtmEventListeners = (prevControl, nextControl, slideShowName) => {
		prevControl.addEventListener('click', function () {
			dataLayer.push({
				event: 'slideshow',
				slideshowAction: 'previous',
				slideshowName: slideShowName,
				slideName: $.trim($('.eon-life__item.active .eon-life__text').first().text()),
			});
		});

		nextControl.addEventListener('click', function () {
			dataLayer.push({
				event: 'slideshow',
				slideshowAction: 'next',
				slideshowName: slideShowName,
				slideName: $.trim($('.eon-life__item.active .eon-life__text').first().text()),
			});
		});
	};

	const GtmOnLoad = (slideShowName) => {
		dataLayer.push({
			event: 'slideshow',
			slideshowAction: 'load',
			slideshowName: slideShowName,
			slideName: $.trim($('.eon-life__item.active .eon-life__text').first().text()),
		});
	};

	const jsEonLifeCarousel = document.querySelectorAll('.js-eon-life-carousel');
	const slideShowName = $.trim($('.eon-life').siblings('h2').text());

	Array.from(jsEonLifeCarousel).forEach((item) => {
		const prevControl = item.nextElementSibling.querySelector('.slider-control__arrow-prev');
		const nextControl = item.nextElementSibling.querySelector('.slider-control__arrow-next');

		new Glider(item, {
			slidesToShow: 1,
			slidesToScroll: 1,
			draggable: false,
			duration: 0.3,
			arrows: {
				prev: prevControl,
				next: nextControl,
			},
		});
		if (item.querySelectorAll('.eon-life__item').length < 2) {
			item.parentElement.querySelector('.slider-control').classList.add('u-hide');
		} else {
			addGtmEventListeners(prevControl, nextControl, slideShowName);
		}
		GtmOnLoad(slideShowName);
	});
};
